const en = {
    login:{ 
    	title:'I am the title',
    },

    tip: {
        payment_currency: 'payment currency',
        payment_amount: '支付金额',
    }
}
export default en;
